import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Tracking = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.moon_100};
  padding: ${({ theme: { reference } }) => `${reference.dimension_40} ${reference.dimension_16}`};
`;

export const TrackingHeader = styled(FlexContainer)`
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TrackingContent = styled(FlexContainer)`
  padding: ${({ theme: { sizing } }) => `${sizing.fds_size_40} ${sizing.fds_size_48}`};
  width: 100%;
  max-width: 1060px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: ${({ theme: { sizing } }) => sizing.fds_size_16};
  }
`;

export const TrackingBox = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  padding: ${({ theme: { sizing } }) => sizing.fds_size_24};
  border: 1px solid ${({ theme: { colors } }) => colors.sky_300};
`;

export const TrackingContainer = styled(FlexContainer)`
  width: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    flex-direction: column;
  }
`;

export const TrackingProgress = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.grass_100};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  width: 70%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ExtraFriend = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.sky_200};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    justify-content: center;
  }
`;

export const InviteLink = styled.button`
  :hover {
    transform: scale(1.03);
  }
`;
